<style lang="scss" scoped></style>

<template>
  <workspace-layout>
    <template v-slot:breadcrumbs>
      <el-breadcrumbs :canEdit="false" :showCrumb="true" :parents="[]" :current="{ title: $t(`${$options.name}.title`) }" />
    </template>

    <template v-slot:actions>
      <div>
        <router-link class="btn btn-primary" :to="{ name: 'workspace-templates-create', params: { workspaceId: workspace.id } }"> {{ $t('general.add') }} </router-link>
      </div>
    </template>

    <template v-slot:filters>
      <table-filters v-model="filters"></table-filters>
    </template>

    <template v-slot:page>
      <vue-good-table class="pt-40 pb-32" :columns="columns" @on-row-click="goTo" :rows="tableData" @on-selected-rows-change="selectionChanged" styleClass="vgt-table light-table">
        <template slot="table-row" slot-scope="slotProps">
          <span v-if="slotProps.column.field === 'creator' && slotProps.row.creator" class="d-flex flex-row align-contents-center">
            <el-avatar class="my-auto" :user="slotProps.row.creator"></el-avatar>
            <p class="my-auto ml-8">{{ slotProps.row.creator.first_name }} {{ slotProps.row.creator.last_name }}</p>
          </span>

          <span v-if="slotProps.column.field === 'parent_id'">
            <span v-if="!slotProps.formattedRow[slotProps.column.field]">
              <p class="vgt-text-disabled text-right">{{ $t(`${$options.name}.edit_no`) }}</p>
            </span>
            <span v-else>
              <p class="text-right">{{ $t(`${$options.name}.edit_yes`) }}</p>
            </span>
          </span>

          <span v-if="!slotProps.row.parent_id" class="vgt-text-disabled">
            {{ slotProps.formattedRow[slotProps.column.field] }}
          </span>
          <span v-else-if="slotProps.formattedRow[slotProps.column.field] && slotProps.column.field !== 'parent_id'">
            {{ slotProps.formattedRow[slotProps.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </template>
  </workspace-layout>
</template>

<script>
import WorkspaceLayout from '@/layouts/workspace';
import HasTableFilter from '@/components/elements/table/has-table-filter';

import { ElBreadcrumbs } from '@/components/elements/_index';
import { VueGoodTable } from 'vue-good-table';

export default {
  name: 'views.workspace.templates',

  mixins: [HasTableFilter],

  components: { WorkspaceLayout, ElBreadcrumbs, VueGoodTable },

  data() {
    return {
      columns: [
        { width: '250px', label: this.$t(`${this.$options.name}.template`), field: 'title', sortable: true },
        { width: '150px', label: this.$t(`${this.$options.name}.last_updated`), field: 'updated_at', sortable: true, type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP' },
        { width: '150px', label: this.$t(`${this.$options.name}.created_at`), field: 'created_at', sortable: true, type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP' },
        { width: '50px', label: this.$t(`${this.$options.name}.editable`), field: 'parent_id', sortable: true },
      ],
      selectedTemplates: [],
      filters: {
        search: {
          value: '',
          type: 'search',
        },
        updated_at: {
          selected: { startDate: null, endDate: null },
          type: 'date',
        },
        created_at: {
          selected: { startDate: null, endDate: null },
          type: 'date',
        },
      },
    };
  },

  methods: {
    goTo(params) {
      if (!params.row.parent_id) {
        return;
      }
      if (params.column === 0) {
        return;
      }
      this.$router.push({ name: 'workspaces-templates-update', params: { workspaceId: this.workspace.id, templateId: params.row.id } });
    },
    selectionChanged() {},
  },

  computed: {
    templates() {
      return this.$store.getters['template/all'];
    },
    workspace() {
      return this.$store.getters['workspace/current'];
    },
    tableData() {
      return this.templates.filter(data => {
        return this.searchMatched(['title'], data) && this.isValidDate('created_at', data.created_at) && this.isValidDate('updated_at', data.updated_at);
      });
    },
  },
};
</script>
